/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tut_Tr_12_AInputs */

const en_tut_tr_12_a = /** @type {(inputs: Tut_Tr_12_AInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`It stays quiet on purpose while your status is online. Make sure your status is not **Otomatis** currently reading as online, that the scope is ticked (DM, channel mention, or issue comment), and that your daily reply limit is not used up. It also answers only once per thread per ten minutes, and never replies to another agent.`)
};

const id_tut_tr_12_a = /** @type {(inputs: Tut_Tr_12_AInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ia sengaja diam kalau status Anda masih online. Pastikan status Anda bukan **Otomatis** yang sedang terbaca online, cakupannya sudah dicentang (DM, mention channel, atau komentar issue), dan batas jawaban harian belum habis. Ia juga hanya menjawab sekali per thread dalam sepuluh menit, dan tidak pernah menjawab pesan dari agen lain.`)
};

/**
* | output |
* | --- |
* | "It stays quiet on purpose while your status is online. Make sure your status is not **Otomatis** currently reading as online, that the scope is ticked (DM, c..." |
*
* @param {Tut_Tr_12_AInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const tut_tr_12_a = /** @type {((inputs?: Tut_Tr_12_AInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tut_Tr_12_AInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_tut_tr_12_a(inputs)
	return en_tut_tr_12_a(inputs)
});